const statusHtml = require("./html/status.html");
const allWarehousesHtml = require('./html/allWarehouses.html');
const warehouseChildRowHtml = require('./html/warehouseChildRow.html');
// const setDash = require("./html/setToDash.html");
import $ from 'jquery';
import _ from "underscore";
import run from '../../../utilities/run';
import render from "../../../utilities/render";
import {setElementsFromScope, setOptionsForSelect} from "../../../utilities/selectorHelpers";
import {isPresent} from "../../../utilities/general";
import {bindCheckboxRowItems, addSimpleCheckboxRows} from "../../../utilities/additionalFilterLogic";
import {applySortingRelatedIconsAndSetHiddenFields} from "../../../utilities/filtersLegacy";
import collectDataAttributesFor from "../../../utilities/collectDataAttributesFor";
import {matchChildrenWidthsToParentCols} from "../../../utilities/jqueryDataTableChildren";
import {inventoryLookupFieldDropdown} from "./filter/inventoryLookupFieldDropdown.js";
import {flipArrowIcon} from "../../../utilities/fontAwesomeHelpers";
require("./lookup.less");
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT,SUCCESS_MODAL_TIMEOUT} from "../../../constants";
//import pagination from "../../../components/pagination/pagination";



import LookupTable from "../../../components/lookupTable/index";

import {buildExport,retriveCriteriaObjectByKey,removeSpecificObjectFromSearchCriteria,prepareDataToSendController,isEdit,readSpecificObjectFromCurrentData,doAjax,readSpecificKeyFromSearchCriteria,alterSearchCriteriForController,pushFilterSessionCacheState,retriveCriteriaObjectByOperation,isNew,isDeleteView,isOnlyLookupDataUpdate} from "../../../utilities/filtersutil";
import {keyDefaultFalseOption} from '../../../utilities/general';
const targetSelector = "#lookup-item-inventory-outer";
const lookupSelector = "#lookup-item-inventory-wrapper";
import {handleCustomDropdownEvents} from "../../../utilities/customBootstrapDropdowns";
let actionCellDropdownTemplate = require('../../../components/lookupTable/html/utilRenderTemplates/actionCellDropdown.html');
let actionCellDropdownItemTemplate = require('../../../components/lookupTable/html/utilRenderTemplates/actionCellDropdownItem.html');
let actionHeaderDropdownTemplate = require('../../../components/lookupTable/html/utilRenderTemplates/actionHeaderDropdown.html');

run(targetSelector, ()=>{

  const statusClassMap = {
    "Out of Stock": "q-pill-red",
    "Low Stock": "q-pill-orange",
    "_available": "q-pill-white-and-grey"
  }
  const savedViews  =  $(targetSelector).data("saved-views");
  const saveViewURL  =  $(targetSelector).data("save-view-url");
  const deleteViewURL  =  $(targetSelector).data("delete-view-url");
  const dataTableComponentData =  $(targetSelector).data("inventory-lookup-data");
  const filterURL  =  $(targetSelector).data("filter-item-inventory-url");
  const exportItemInventoryUrl = $(targetSelector).data("export-item-inventory-url");
  const filterFlag = $(targetSelector).data("filter-flag");
  const facCode = $(targetSelector).data("fac-code");

  let exportModal = new buildExport(); 


  var inventoryLookup = new LookupTable({      
   
    target: $("#lookup-item-inventory-wrapper"),
    minWidthClass: "q-min-width-sm-til-md",
    mobileColumns: [
      {
        data: "itemSku",
        title: "Product Name (SKU)",
        class: "dtc-min-width-md"
      },
      {
        data: "productName",
        title: "Product Description",
        class: "dtc-min-width-lg"
      },
      {
        data: "facilityLocation",
        title: "Facility",
        class: "dtc-min-width-sm"
      },
      {
        data: "available",
        title: "Available",
        class: "dtc-min-width-sm"
      },
      {
        data: "allocated",
        title: "Committed",
        class: "dtc-min-width-sm"
      },
      {
        data: "blocked",
        title: "Blocked",
        class: "dtc-min-width-sm"
      },
      {
        data: "inboundInventory",
        title: "Inbound Inventor",
        class: "dtc-min-width-sm"
      },
      {
        data: "inboundReturns",
        title: "Inbound Returns",
        class: "dtc-min-width-sm"
      },
      {
        data: "backordered",
        title: "Backordered",
        class: "dtc-min-width-sm"
      }
    ],
    tableSearchInput: {
      placeholder: 'Search',
      value: ""
    },
    tableSearchDropdown: {
      selected: "",   
      columns:inventoryLookupFieldDropdown
    },
    savedViews: savedViews,
    bulkSelect: false,
    dataTable: {
      data: dataTableComponentData.content,
      columnDefs: [
        { className: "custom-class", targets: [ 1 ] }
       ],
        order: [
          [3, 'desc'],
        ],
        columns: [ 
          {
            data: "itemSku",
            title: "Product Name (SKU)",
            class: "dtc-min-width-md"
          },
          {
            data: "productName",
            title: "Product Description",
            class: "dtc-min-width-lg"
          },
          {
            data: "facilityLocation",
            title: "Facility",
            class: "dtc-min-width-sm"
          },
          {
            data: "available",
            title: "Available",
            class: "dtc-min-width-sm",
            render:renderAvailableStatus
          },
          {
            data: "allocated",
            title: "Committed",
            class: "dtc-min-width-sm"
          },
          {
            data: "blocked",
            title: "Blocked" ,
            class: "dtc-min-width-sm"       
          },
          {
            data: "inboundInventory",
            title: "Inbound Inventory",
            class: "dtc-min-width-sm"
          },
          {
            data: "inboundReturns",
            title: "Inbound Returns",
            class: "dtc-min-width-sm"
          },
          {
            data: "backordered",
            title: "Backordered",
            class: "dtc-min-width-sm"
          }
        ]
      }, 
      paginationData:dataTableComponentData.page,
      filterModal: {
        title: "Filter Inventory:",
        tableType: "Inventory"
      },
      onFetch: function() {
        inventoryLookup.showLoadingOverlay();
         let currentData = inventoryLookup.generateData();
        if(isOnlyLookupDataUpdate(currentData)){
          setTimeout(() => {
            doAjax({url: filterURL, success: filterSuccessFun, error: errorFun,data:getInventoryData(currentData)});
          },SUCCESS_MODAL_TIMEOUT);
        }else if(isNew(currentData)){
          setTimeout(() => {
            doAjax({url: saveViewURL, success: savedViewSuccess, error: errorFun, data:getInventoryData(currentData)});
          },SUCCESS_MODAL_TIMEOUT);
        }else if(isEdit(currentData)){
          setTimeout(() => {
            doAjax({url: saveViewURL, success: savedEditViewSuccess, error: errorFun, data:getInventoryData(currentData)});
          },SUCCESS_MODAL_TIMEOUT);
        }else if(isDeleteView(currentData)){     
          setTimeout(() => {
            doAjax({url: deleteViewURL, success: delteViewScussFun, error: errorFun, data:getInventoryData(currentData)});
          },SUCCESS_MODAL_TIMEOUT);
        } 

     
        
      }  
   });

  inventoryLookup.init();


  function getInventoryData(currentData){
        let sourceData = prepareDataToSendController(currentData)
        let revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"]);
        let warehouseObj = retriveCriteriaObjectByKey(revisedSearchCriteria,"warehouse");
        let prepareInventoryData = {
          ...sourceData,
          warehouse: isPresent(warehouseObj) ? warehouseObj.value[0]  : "all warehouses"
        }
        return prepareInventoryData;
  }


  function filterSuccessFun(data){ 
    let inventory = data.content;
    let page = data.page;
    inventoryLookup.setNewData(inventory);
    inventoryLookup.setPaginationData(page)
    inventoryLookup.hideLoadingOverlay();
    setExportData(inventoryLookup.generateData());

  }

  function savedViewSuccess(data){ 
    let inventory = data.lookupOrderJSON.content;
    let page = data.lookupOrderJSON.page;
    inventoryLookup.setNewData(inventory);
    inventoryLookup.setPaginationData(page);
    inventoryLookup.setNewSavedViewData(data.savedView, "newSavedView");
    inventoryLookup.hideLoadingOverlay();
    setExportData(inventoryLookup.generateData());
  }


  function savedEditViewSuccess(data){ 
    let inventory = data.lookupOrderJSON.content;
    let page = data.lookupOrderJSON.page;
    inventoryLookup.setNewData(inventory);
    inventoryLookup.setPaginationData(page);
    inventoryLookup.setNewSavedViewData(data.savedView, data.savedView.target);
    inventoryLookup.hideLoadingOverlay();
    setExportData(inventoryLookup.generateData());
  }


  function delteViewScussFun(data){ 
    let inventory = data.lookupOrderJSON.content;
    let page = data.lookupOrderJSON.page;
    inventoryLookup.removeSavedView(data.target);
    inventoryLookup.setNewData(inventory);
    inventoryLookup.setPaginationData(page);
    inventoryLookup.hideLoadingOverlay();
    setExportData(inventoryLookup.generateData());
  }

  function errorFun(data){
    inventoryLookup.hideLoadingOverlay();
  }

  function renderAvailableStatus(data, type, row) {
    return render(
      statusHtml,
      {
        statusText: data,
        statusClass: getStatusClass(row.invStatus)
      }
    )
  }

  function getStatusClass(val){
    return statusClassMap[val] || statusClassMap._available;
  }


   function initExport() {
      let exportObj  =  {
        title : $(targetSelector).data("export-popup-title"), 
        exportAttemptTextPart1Lang: $(targetSelector).data("export-attempt-text-part1"), 
        exportAttemptTextPart2Lang: $(targetSelector).data("export-attempt-text-part2"),
        exportMaxLimitLang: $(targetSelector).data("export-max-row-limit")
      }; 
      exportModal.init(exportObj);
      exportModal.bindExportEvent();
    }

    function setExportData(currentData) {
      exportModal.buildExportBasicURL(exportItemInventoryUrl,currentData);
      let url = exportModal.getCurrentUrl();
      let revisedSearchCriteria =  alterSearchCriteriForController(currentData["searchCriteria"]);
      let warehouseObj = retriveCriteriaObjectByKey(revisedSearchCriteria,"warehouse");
      let warehouse= isPresent(warehouseObj) ? warehouseObj.value[0]  : "all warehouses"
      url =  url +"&warehouse="+warehouse;
      exportModal.buildExportBasicURL(url,currentData);
      exportModal.setExportCount(currentData.totalElements);
    }

    initExport();
    setExportData(inventoryLookup.generateData());
});



// WEBPACK FOOTER //
// ./src/pages/inventory/lookup/lookup.js